/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCurrentFluiditeResult } from '../../models/get-current-fluidite-result';

export interface GetByRestaurantidCurrentfluidite$Params {
  RestaurantId: number;
}

export function getByRestaurantidCurrentfluidite(
  http: HttpClient,
  rootUrl: string,
  params: GetByRestaurantidCurrentfluidite$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetCurrentFluiditeResult>> {
  const rb = new RequestBuilder(rootUrl, getByRestaurantidCurrentfluidite.PATH, 'get');
  if (params) {
    rb.path('RestaurantId', params.RestaurantId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCurrentFluiditeResult>;
    }),
  );
}

getByRestaurantidCurrentfluidite.PATH = '/Restaurants/{RestaurantId}/currentFluidite';
